import { avc, ini } from '@cls/shared';

interface Props {
  name: string;
  photo?: string | null;
  size?: number;
  fontSize?: number;
  title?: string;
}

export function Avatar({ name, photo, size = 34, fontSize = 12, title }: Props) {
  if (photo) {
    return (
      <div className="av av-photo" style={{ width: size, height: size }} title={title ?? name}>
        <img src={photo} alt={name} loading="lazy" />
      </div>
    );
  }
  return (
    <div
      className="av"
      style={{ width: size, height: size, fontSize, background: avc(name) }}
      title={title ?? name}
    >
      {ini(name)}
    </div>
  );
}
